// @ts-check

/** @type import("../../../types/images").Image */
export default {
  "high-five": {
    aliases: [],
    file: "illustration/horizon/high-five.svg",
  },
};
